(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/keno/components/fractiongames/assets/react/fractiongames-app.js') >= 0) return;  svs.modules.push('/modules/keno/components/fractiongames/assets/react/fractiongames-app.js');

'use strict';

const _svs$numbergames = svs.numbergames,
  FractiongamesBanner = _svs$numbergames.FractiongamesBanner,
  productMapping = _svs$numbergames.productMapping;
const FractionGamesProvider = svs.numbergames.fractiongames.redux.FractionGamesProvider;
const Fractiongames = svs.keno.components.fractiongames.Fractiongames;
const FractiongamesApp = () => React.createElement(React.Fragment, null, React.createElement(FractiongamesBanner, null), React.createElement(FractionGamesProvider, null, React.createElement(Fractiongames, {
  productFilter: productMapping.CONSTANTS.KENO
})));
svs.keno.components.fractiongames.FractiongamesApp = FractiongamesApp;

 })(window);